import tw, { styled } from 'twin.macro';

const Timeline = styled.div`
  width: 1px;
  height: 100%;
  ${tw`bg-gray-100`}
`;

export default Timeline;
